import { importClass } from "../../utilities/dynamicImportsUtility";

export default class PageScrollerElement extends HTMLElement {
  public constructor() {
    super();
  }

  public connectedCallback() {
    console.debug("Page Scroller Element registered");
    if (document.readyState === "loading") {
      window.addEventListener("DOMContentLoaded", () => this.initialize());
    } else {
      this.initialize();
    }
  }

  private async initialize() {
    importClass(
      () =>
        import(
          /* webpackChunkName: "pageScrollerController" */ "./pageScrollerController"
        ),
      true,
      [this]
    );
  }
}

customElements.define("page-scroller", PageScrollerElement);
